<template>
  <div>
    <v-row>
      <v-col cols="12" sm="12" offset-sm="0">
        <v-card>
          <v-card-title>
            {{ this.title }}
          </v-card-title>
          <v-container fluid>
            <v-row>
              <v-container fluid>
                <v-select
                  :items="options"
                  v-model="selected"
                  label="Select folder"
                  outlined
                  @change="onChange()"
                  style="margin:0px"
                ></v-select>
              </v-container>
              <v-col
                v-for="im in images"
                :key="im"
                class="d-flex child-flex"
                cols="2"
              >
                <v-card tile>
                  <v-img
                    :src="im"
                    :lazy-src="im"
                    aspect-ratio="1"
                    class="grey lighten-2"
                    v-on:click="displayImg(im)"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                  <div style="text-align:center; font-size:9pt;">
                    {{ displayInfo(im) }}
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    dense: false,
    fixedHeader: false,
    height: 300,
    docs: [],
    docsURL: [],
    images: [],
    kmls: [],
    selected: [],
    options: [],
    pathFile: "",
    show_imgs: false
  }),
  props: {
    path: String,
    title: {
      type: String,
      default: "Documents"
    },
    selectBox: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onChange() {
      let tab = [];
      for (let p in this.results) {
        if (this.selected == p) tab = this.results[p];
      }

      this.displayResults(tab);
    },
    getResults: function() {
      this.show_imgs = false;
      this.options = [];
      this.docs = [];
      this.docsURL = [];
      this.images = [];
      let wurl =
        "https://observations.ipsl.fr/aeris/eurec4aprod/list.php?p=" +
        this.pathFile;
      wurl = wurl + "&gen=true";

      axios.get(wurl).then(response => {
        this.results = response.data;
        let tab = [];
        if (this.selectBox) {
          for (let p in response.data) {
            if (Array.isArray(response.data[p])) {
              this.options.unshift(p);
              this.selected = p;
              tab = response.data[p];
            }
          }
        } else tab = response.data;

        this.displayResults(tab);
      });
    },
    displayResults: function(tab) {
      this.docs = [];
      this.docsURL = [];
      this.images = [];
      this.kmls = [];
      this.show_docs = false;
      this.show_imgs = false;

      for (let i = 0; i < tab.length; i++) {
        let ext = tab[i].substring(tab[i].lastIndexOf(".")).toUpperCase();

        if (ext == ".PNG" || ext == ".GIF" || ext == ".JPG" || ext == ".JPEG") {
          this.images.push(
            "https://observations.ipsl.fr/aeris/eurec4a-data/" + tab[i]
          );
          this.show_imgs = true;
        }
      }
    },
    displayImg: function(imag) {
      window.open(imag);
    },
    displayInfo: function(imag) {
      var filename = imag.substring(imag.lastIndexOf("/") + 1);
      return filename;
    },
    displayDoc: function(d) {
      window.open("https://observations.ipsl.fr/aeris/eurec4a-data/" + d);
    }
  },
  mounted: function() {
    this.pathFile = this.path;
    this.getResults();
  },
  computed: {
    getContent() {
      return this.path;
    }
  },
  watch: {
    getContent(newContent, oldContent) {
      this.pathFile = newContent;
      this.getResults();
    }
  }
};
</script>
